<div class="EXTRA_SERVICE_VISA_FORM modal-header w-100 d-inline-block border-bottom pb-0 mb-0">
  <div class="d-flex justify-content-between">
    <h4 class="booking-modal-title">Immigration & Visas</h4>
    <p class="modal-clost-btn" (click)="bsModalRef?.hide()" aria-label="Close">&times;</p>
  </div>
  <div>
  </div>
</div>
<div class="modal-body p-4 mt-3">
  <p class="my-3 intro">Our team are available on the go to assist & support with your Immigration & Visas request.</p>
  <form [formGroup]="form">
    <div class="form-group mb-3">
      <div class="row">
        <label class=" form-label ">
          Destination Country <span class="text-danger">*</span>
        </label>

        <div class="col-12 form-input">
          <app-location-selector className="input-locator" placeholder="Enter country travellers are visiting"
            [showErrorMsg]="false" [showExample]="false" [showPrefixPadding]="false" [showPrefixIcon]="false"
            (values)="locationChangeF($event)">
          </app-location-selector>
        </div>
        <div class="col-12 form-input ">
          
          <app-input-list-group [lists]="form.value.nationality_of_travelers" [formData]="otherFacilitiesData.form"
          [formGrp]="form" formCtrlName="nationality_of_travelers" (removedElement)="getRemovedRule($event)" ></app-input-list-group>

        </div>
        <div class="col-12 form-input ">
          <label class=" form-label ">
            Purpose of Travel <span class="text-danger">*</span>
          </label>
          <app-input formCtrlName="purpose_of_travel" [label]="'State the reason for the travellers visit'"
            [formGrp]="form" text [required]="true">
          </app-input>
        </div>
              <div class="form-group mb-3">
            <label class=" form-label ">
              Length of Stay <span class="text-danger">*</span>
            </label>
            <div class="row">
              <div class="col-6 form-input">
                <app-input  formCtrlName="startDate" [label]="'Start date'" [min]="minDate" (changeEvent)="getDate($event)" [formGrp]="form" date [required]="true">
                </app-input>
              </div>
              <div class="col-6 form-input ">

                <app-input  formCtrlName="endDate" [label]="'End date'" [formGrp]="form" [min]="minDate" date [required]="true">
                </app-input>
              </div>

            </div>
          </div>


      </div>
    </div>

    
    <div class="col-12 form-input mb-3">
    <label class="form-label required">Max budget <span>*</span></label>

    <div class="budget-wrapper">
      <select class="budget-currency col-2" formControlName="currency">
        <option *ngFor="let currency of currencies" [value]="currency.name">
          {{ currency.name }}
        </option>
      </select>

      <app-input class="budget-input col-10" formCtrlName="max_budget" [formGrp]="form" inputNumber placeholder="Enter max budget" [required]="true">
      </app-input>
    </div>
    </div>
   
    <div class="mb-3 ">

      <label class="mt-2 form-label form-toggle">
        Additional Request
      </label>
      <textarea formControlName="additional_requests"
        placeholder="Any special requests or preferences, such as expedited visa processing or assistance with visa applications"
        class="form-control form-input booking-text-area text-body" cols="10" rows="5"></textarea>


    </div>
    <app-button class="book-btn" [disabled]="form.invalid" (click)="submit()" [className]="'w-100'" warning>
      {{loading ? 'Loading...': 'Submit'}}
    </app-button>
  </form>


</div>
